import { render, staticRenderFns } from "./header-pri.vue?vue&type=template&id=0f0ba74e&scoped=true"
import script from "./header-pri.vue?vue&type=script&lang=js"
export * from "./header-pri.vue?vue&type=script&lang=js"
import style0 from "./header-pri.vue?vue&type=style&index=0&id=0f0ba74e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0ba74e",
  null
  
)

export default component.exports